module.exports = __webpack_public_path__ + "static/media/29BDOS12.73de103c.jpg";